export default __webpack_public_path__ + "static/media/park.0f960a75.jpg";